import ClassNames from '@/interfaces/ClassNames.interface';

const defaultClassNames = {
  tabClass: '',
  tabPaginationleft: '',
  tabPaginationPreviousButton: '',
  tabPaginationRight: '',
  tabPaginationNextButton: '',
  tabPaginationUpButton: '',
  tabPaginationDownButton: '',
  tabDays: '',
  tabDayDisplay: '',
  tabMeetings: '',
  tabMeeting: '',
  tabMeetingButton: '',
  tabMeetingEmpty: '',
  tabLoading: '',
};

export default defaultClassNames;
